import * as THREE from 'three';
import Action from '../classes/Action';
import DefaultSceneManager from '../classes/DefaultSceneManager';
import { CustomEventTypes, SaveModificationTypes } from '../globals';
import Scenario from "../classes/scenarioElements/Scenario";
import ProjectSaver from '../classes/ProjectSaver';
import MathUtils from '../classes/utilities/MathUtils';
import Callout from "../classes/Callout";
import TransformUtils from "../classes/utilities/TransformUtils";

export default class TranslateObjectWithoutChildrenAction extends Action
{
	constructor(objects: THREE.Object3D[], newPositions: THREE.Vector3[], oldPositions: THREE.Vector3[])
	{
		const actionName = objects.length > 1 ? "Translated objects" : "Translated " + objects[0].name;
		const isDefaultState = Scenario.currentStep()?.isDefault();

		const childrenInitialPositionsMap = new Map<string, THREE.Vector3[]>();
		for(const object of objects)
		{
			const initialPositionsArray: THREE.Vector3[] = [];
			for (const child of object.children)
			{
				if (!(child instanceof Callout))
				{
					const worldPosition = new THREE.Vector3();
					child.getWorldPosition(worldPosition);
					initialPositionsArray.push(worldPosition);
				}
			}
			childrenInitialPositionsMap.set(object.userData.guid, initialPositionsArray);
		}

		super([objects, newPositions, childrenInitialPositionsMap, isDefaultState],
			[objects, oldPositions, childrenInitialPositionsMap, isDefaultState],
			actionName,
			[objects, newPositions, oldPositions]);
	}

	do(objects: THREE.Object3D[], positions: THREE.Vector3[], childrenInitialPositionsMap: Map<string, THREE.Vector3[]>, isDefaultState: boolean)
	{
		if (isDefaultState) DefaultSceneManager.getInstance().syncTranslateWithoutChildren(objects, positions);

		for(let i = 0; i < objects.length; i++)
		{
			const object = objects[i];
			object.position.copy(positions[i]);
			ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Position);
	
			let childIndex = 0;
			const initialPositionsArray = childrenInitialPositionsMap.get(object.userData.guid)!;
			for (const child of object.children)
			{
				if (!(child instanceof Callout))
				{
					TransformUtils.setWorldPosition(child, initialPositionsArray[childIndex++]);
					ProjectSaver.getInstance().markModifiedObject(child, SaveModificationTypes.Position);
				}
			}
		}
		
		document.dispatchEvent(new CustomEvent(CustomEventTypes.selectedObjectPositionChanged));
	}

	verify(objects: THREE.Object3D[], newPositions: THREE.Vector3[], oldPositions: THREE.Vector3[])
	{
		if (objects.length === 0 || objects.length !== newPositions.length || objects.length !== oldPositions.length || newPositions.length !== oldPositions.length)
		{
			return false;
		}

		let difference = false;
		for (let i = 0; i < objects.length; i++)
		{
			if (!MathUtils.areVectorsEqual(newPositions[i], oldPositions[i]))
			{
				difference = true;
				break;
			}
		}

		return difference;
	}
}
